import { useEffect } from "react";

import { fetchSiteSpecificCodes } from "shared/actions/siteSpecificCodesActions";
import { useHasLoaded, useIsLoading } from "shared/hooks/requestStatusHooks";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { selectSiteSpecificCodes } from "selectors/siteSpecificCodesSelector";
import { useAppDispatch, useAppSelector } from "store/hooks";

const useSiteSpecificCodes = (
  { fetchCodes = false }: { fetchCodes: boolean } = {
    fetchCodes: false,
  }
) => {
  const dispatch = useAppDispatch();
  const siteSpecificICD10Feature = useAppSelector((state) =>
    selectFeatureFlag(state, "siteSpecificICD10")
  );
  const { nosCodes, nosToSiteSpecificCodes, termsToSite } = useAppSelector(
    selectSiteSpecificCodes
  );
  const siteSpecificCodes = useAppSelector(
    ({ siteSpecificCodes }) => siteSpecificCodes
  );
  const siteSpecificCodesLoaded = useHasLoaded(fetchSiteSpecificCodes);
  const siteSpecificCodesLoading = useIsLoading(fetchSiteSpecificCodes);

  useEffect(() => {
    if (
      siteSpecificICD10Feature &&
      (!siteSpecificCodesLoaded || !siteSpecificCodes) &&
      !siteSpecificCodesLoading &&
      fetchCodes
    ) {
      dispatch(fetchSiteSpecificCodes());
    }
  }, [
    siteSpecificICD10Feature,
    siteSpecificCodesLoading,
    siteSpecificCodesLoaded,
    siteSpecificCodes,
    fetchCodes,
  ]);

  return {
    siteSpecificICD10Feature,
    siteSpecificCodesLoaded,

    nosCodes,
    nosToSiteSpecificCodes,
    termsToSite,
  };
};

export default useSiteSpecificCodes;
